class ProductDetailService {
    /*@ngInject*/
    constructor($log, $http, $timeout, $rootScope, CommonService) {
        this.$log = $log;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.variantData = null;
        this.warningSelectSize = false;
        this.CommonService = CommonService;
    }

    requestVariantData(code, s2sAddToCart) {
        this.$log.debug('Get variantData for ' + code);

        let url = this.CommonService.getBaseUrl() + '/p/' + code + '/variantData';
        this.$http.get(url, null)
            .then((response) => {
                this.variantData = response.data;
                this.warningSelectSize = false;
                this.$rootScope.$broadcast('variantDataSuccess');
                if (s2sAddToCart && this.variantData !== null && this.variantData.availableForCheckout) {
                    this.$rootScope.$broadcast('addToCartTrigger');
                    if (window.dataLayer !== undefined) {
                        dataLayer.push({'event': 's2sAddToCart'});
                    }

                }
            }, (error) => {
                this.$log.error('variantData for product: ' + error.status + ' ' + error.statusText);
            });
    }

    formatPrice(defaultPrice, priceData) {
        if (this.variantData == null) {
            return defaultPrice;
        } else {
            return (priceData == null) ? '' : priceData.formattedValue;
        }
    }

    getVariantData() {
        return this.variantData;
    }

    setVariantData(variantData) {
        this.variantData = variantData;
    }

    setWarningSelectSize(warningSelectSize) {
        this.warningSelectSize = warningSelectSize;
    }

    getWarningSelectSize() {
        return this.warningSelectSize;
    }

    availableForCheckout() {
        let variantData = this.getVariantData();
        if (variantData != null) {
            return variantData.availableForCheckout;
        }
        return true;
    }

}

export default ProductDetailService;
